import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home, Search, ArrowLeft, MapPin } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-purple-50 flex items-center justify-center px-4">
      <Helmet>
        <title>Sayfa Bulunamadı - 404 | DavetEviBul</title>
        <meta name="description" content="Aradığınız sayfa bulunamadı. Ana sayfaya dönün veya davet evlerini keşfedin." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="max-w-2xl w-full text-center">
        {/* 404 Illustration */}
        <div className="relative mb-8">
          <div className="text-[180px] md:text-[220px] font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 leading-none select-none">
            404
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-32 h-32 md:w-40 md:h-40 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full opacity-20 animate-pulse" />
          </div>
        </div>

        {/* Message */}
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Sayfa Bulunamadı
        </h1>
        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
          Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir. 
          Endişelenmeyin, sizi doğru yere yönlendirelim!
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <Button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <Home className="w-5 h-5 mr-2" />
            Ana Sayfaya Dön
          </Button>
          <Button
            onClick={() => navigate('/davet-evleri')}
            variant="outline"
            className="border-2 border-pink-300 text-pink-600 hover:bg-pink-50 px-8 py-6 text-lg rounded-xl transition-all duration-300"
          >
            <Search className="w-5 h-5 mr-2" />
            Davet Evlerini Keşfet
          </Button>
        </div>

        {/* Quick Links */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-gray-100">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Popüler Sayfalar</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              { name: 'İstanbul', path: '/istanbul' },
              { name: 'Ankara', path: '/ankara' },
              { name: 'İzmir', path: '/izmir' },
              { name: 'Bursa', path: '/bursa' },
            ].map((city) => (
              <button
                key={city.path}
                onClick={() => navigate(city.path)}
                className="flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-gray-50 to-gray-100 hover:from-pink-50 hover:to-purple-50 rounded-xl text-gray-700 hover:text-pink-600 font-medium transition-all duration-300 group"
              >
                <MapPin className="w-4 h-4 text-pink-400 group-hover:scale-110 transition-transform" />
                {city.name}
              </button>
            ))}
          </div>
        </div>

        {/* Back Button */}
        <button
          onClick={() => navigate(-1)}
          className="mt-8 inline-flex items-center text-gray-500 hover:text-pink-600 transition-colors"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Önceki sayfaya dön
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
